import { defineElement, html, TemplateElement } from '@webtides/element-js';
import styles from './_filter-meta.css';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';

class FilterMeta extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            filter: [],
            allLabel: 'all',
        };
    }

    watch() {
        return {
            filter: () => {
                const chips = this.chips;
                this.classList.toggle('hidden', this.chips.length === 0);
            },
        };
    }

    changeFilter(filter) {
        this.filter = filter;
        this.requestUpdate();
    }

    get chips() {
        return this.filter
            .map(filter => {
                return filter.values.map((value, index) => {
                    const chip = Object.assign({}, value, { key: filter.key, index });
                    if (filter.key === 'PRICE' && value.key !== 'sale') {
                        chip.label = `${chip.label}: ${CurrencyFormatter.formattedRoundedPrice(chip.value)}`;
                    }
                    return chip;
                });
            })
            .flat()
            .filter(filter => filter && filter.selected === true)
            .sort((first, second) => (first.selectedTime || 0) - (second.selectedTime || 0));
    }

    template() {
        return html`
            ${this.chips.map(
                chip =>
                    html`
                        <spec-chip
                            class="mr-2 last:mr-0 mb-1 mt-1 flex-shrink-0"
                            key="${chip.key}"
                            value="${chip.value}"
                            label="${chip.label}"
                            index="${chip.index}"
                        ></spec-chip>
                    `,
            )}
            ${this.chips.length > 1
                ? html`
                      <spec-chip
                          class="lg:ml-auto order-first lg:order-none mr-2 lg:last:mr-0 mb-1 mt-1 flex-shrink-0"
                          key="all"
                          value="all"
                          label="${this.allLabel}"
                      ></spec-chip>
                  `
                : ''}
        `;
    }
}

defineElement('filter-meta', FilterMeta);
